<div class="local-container">
  <div class="full-height-column">
    <mat-card>
      <mat-toolbar>
        <app-toolbar-directory
          #toolbarDirectory
          [selectedPackagingPartTab]="selectedPackagingPartTab"
          [selectedEntriesCount]="selectedEntryIds.length"
          [isAddEditAllowed]="selectedFoldersPermissions.write"
          [isEnterQuantitiesAllowed]="isEnterQuantitiesAllowed"
          [isComparisonAllowed]="selectedFoldersPermissions.analyze"
          [isRecyclingBinSelected]="isRecyclingBinSelected"
          [selectedDtoFolder]="selectedDtoFolder"
          [rootDtoFolder]="rootDtoFolder"
          (moveClicked)="movePackagingPart()"
          (copyClicked)="copyPackagingPart()"
          (exportClicked)="exportPackagingPart()"
          (deleteClicked)="deletePackagingPart()"
          (createDataExchangeRequestClicked)="createDataExchangeRequest()"
          (restoreClicked)="restorePackagingPart()"
          (compareClicked)="comparePackagingPart()"
          (editQuantityClicked)="editPackagingPartQuantity()"
          (folderUpdated)="updateView()"
          (folderRemoved)="afterFolderRemoved()"
          (editTagsClicked)="editTags()"
          (addTagsClicked)="addTags()"
          (downloadJsonClicked)="downloadJson()"
          (downloadExcelClicked)="downloadEXCEL()"
          (createDocClicked)="createDoc()"
          (createTechnicalDocumentationClicked)="createTechnicalDoc()"
          [(isPpwrViewEnabled)]="isPpwrViewEnabled"
          (isPpwrViewEnabledChange)="onPpwrViewChanged()"
          (setApprovalClicked)="setInternalApproval($event)">
        </app-toolbar-directory>
      </mat-toolbar>
    </mat-card>

    <div class="full-height-row flex-row">
      <mat-card class="treeview-container">
        <app-directory-tree
          [rootFolder]="rootDtoFolder"
          [contextMenu]="contextMenu"
          [selectedFolderIds]="selectedFolderIds"
          [selectable]="true"
          [isRecyclingBinDisabled]="isPpwrViewEnabled"
          [autoSelectSubfolders]="autoSelectSubfolders"
          [expandedFolderIds]="expandedFolderIds"
          (foldersSelected)="onFoldersSelected($event)"
          (contextMenuOpened)="onContextMenuOpened($event)"
          (recyclingBinSelected)="onRecyclingBinSelected($event)"
          (autoSelectSubfoldersChanged)="onAutoSelectSubfoldersChanged($event)"
          (expandedFolderIdsChanged)="onExpandedFolderIdsChanged($event)">
        </app-directory-tree>
      </mat-card>
      <mat-card class="details-container">
        <div class="table-div">
          <div class="local-scrolling-wrapper">
            <ng-template #emptyState>
              <div class="empty-state">
                <mat-icon class="empty-state-icon">folder_open</mat-icon>
                <div class="empty-state-title">
                  {{ 'dataManagement.directory.emptyState.title' | transloco }}
                </div>
                <div class="empty-state-text">
                  {{ 'dataManagement.directory.emptyState.text' | transloco }}
                </div>
              </div>
            </ng-template>

            <mat-tab-group [(selectedIndex)]="selectedPackagingPartTab" (selectedTabChange)="onTabChanged()">
              <mat-tab label="{{ 'packagingSystem.packagingSystems' | transloco }}">
                <ng-container *ngIf="!isPpwrViewEnabled">
                  <app-packaging-systems-overview
                    [hidden]="selectedFolderIds.length === 0 && !isRecyclingBinSelected"
                    [dataSource]="packagingSystemsDataSource"
                    [allTags]="allTags"
                    [displayedColumns]="displayedColumnsPackagingSystems"
                    [isRecyclingBinSelected]="isRecyclingBinSelected"
                    (packagingPartsSelected)="packagingEntriesSelected($event)"
                    [directoryIds]="selectedFolderIds">
                  </app-packaging-systems-overview>
                </ng-container>

                <ng-container *ngIf="isPpwrViewEnabled">
                  <app-packaging-ppwr-overview
                    #ppwrSystemTable
                    [hidden]="selectedFolderIds.length === 0 && !isRecyclingBinSelected"
                    [packagingPart]="packagingPartEnum.System"
                    [dataSource]="packagingPpwrSystemDataSource"
                    [directoryIds]="selectedFolderIds"
                    (packagingPartsSelected)="packagingEntriesSelected($event)">
                  </app-packaging-ppwr-overview>
                </ng-container>

                <ng-container *ngIf="selectedFolderIds.length === 0 && !isRecyclingBinSelected" [ngTemplateOutlet]="emptyState"></ng-container>
              </mat-tab>

              <mat-tab label="{{ 'packagingUnit.packagingUnits' | transloco }}">
                <ng-container *ngIf="!isPpwrViewEnabled">
                  <app-packaging-units-overview
                    [hidden]="selectedFolderIds.length === 0 && !isRecyclingBinSelected"
                    [dataSource]="packagingUnitsDataSource"
                    [allTags]="allTags"
                    [displayedColumns]="displayedColumnsPackagingUnits"
                    [isRecyclingBinSelected]="isRecyclingBinSelected"
                    (packagingPartsSelected)="packagingEntriesSelected($event)"
                    [directoryIds]="selectedFolderIds">
                  </app-packaging-units-overview>
                </ng-container>

                <ng-container *ngIf="isPpwrViewEnabled">
                  <app-packaging-ppwr-overview
                    #ppwrUnitTable
                    [hidden]="selectedFolderIds.length === 0 && !isRecyclingBinSelected"
                    [packagingPart]="packagingPartEnum.Unit"
                    [dataSource]="packagingPpwrUnitDataSource"
                    [directoryIds]="selectedFolderIds"
                    (packagingPartsSelected)="packagingEntriesSelected($event)">
                  </app-packaging-ppwr-overview>
                </ng-container>

                <ng-container *ngIf="selectedFolderIds.length === 0 && !isRecyclingBinSelected" [ngTemplateOutlet]="emptyState"></ng-container>
              </mat-tab>

              <mat-tab label="{{ 'component.packagingComponents' | transloco }}" [disabled]="isPpwrViewEnabled">
                <app-packaging-components-overview
                  [hidden]="selectedFolderIds.length === 0 && !isRecyclingBinSelected"
                  [dataSource]="componentsDataSource"
                  [allTags]="allTags"
                  [displayedColumns]="displayedColumnsComponents"
                  [isRecyclingBinSelected]="isRecyclingBinSelected"
                  (packagingPartsSelected)="packagingEntriesSelected($event)"
                  [directoryIds]="selectedFolderIds">
                </app-packaging-components-overview>
                <ng-container *ngIf="selectedFolderIds.length === 0 && !isRecyclingBinSelected" [ngTemplateOutlet]="emptyState"></ng-container>
              </mat-tab>

              <mat-tab label="{{ 'material.compositeMaterials' | transloco }}" [disabled]="isPpwrViewEnabled">
                <app-composite-materials-overview
                  [hidden]="selectedFolderIds.length === 0 && !isRecyclingBinSelected"
                  [dataSource]="materialsDataSource"
                  [allTags]="allTags"
                  [displayedColumns]="displayedColumnsMaterials"
                  [isRecyclingBinSelected]="isRecyclingBinSelected"
                  (packagingPartsSelected)="packagingEntriesSelected($event)"
                  [directoryIds]="selectedFolderIds">
                </app-composite-materials-overview>
                <ng-container *ngIf="selectedFolderIds.length === 0 && !isRecyclingBinSelected" [ngTemplateOutlet]="emptyState"></ng-container>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </mat-card>
    </div>
  </div>

  <ng-template #contextMenu let-item>
    <mat-card class="context-menu">
      <div *ngIf="item.id !== recyclingBinId && directoryPermissions?.write" [matMenuTriggerFor]="toolbarDirectory.createMenu">
        {{ 'dataManagement.directory.toolbar.create.button' | transloco }}...
      </div>
      <div *ngIf="item.id !== rootDtoFolder.id && item.id !== recyclingBinId" (click)="removeFolder()">
        {{ 'dataManagement.directory.toolbar.removeFolderButton' | transloco }}
      </div>
      <div *ngIf="item.id !== rootDtoFolder.id && item.id !== recyclingBinId" (click)="renameFolder()">
        {{ 'dataManagement.directory.toolbar.renameFolderButton' | transloco }}
      </div>
      <div *ngIf="item.id !== rootDtoFolder.id && item.id !== recyclingBinId" (click)="moveFolder()">
        {{ 'dataManagement.directory.toolbar.moveFolderButton' | transloco }}
      </div>
      <div *ngIf="item.id === recyclingBinId" (click)="emptyRecyclingBin()">
        {{ 'dataManagement.directory.toolbar.contextMenu.emptyBin' | transloco }}
      </div>
      <div *ngIf="item.id === recyclingBinId" (click)="restoreAllItemsFromRecyclingBin()">
        {{ 'dataManagement.directory.toolbar.contextMenu.restoreAll' | transloco }}
      </div>
    </mat-card>
  </ng-template>
</div>